export default __webpack_public_path__ + "static/media/materialize-2.1fbe1852.jpg";